<template>
    <b-container class="pb-2 bg-light mt-2 rounded">
        <page-heading heading="Approved Local Courses"/>
        <b-col class="mx-auto text-left">
            <p class="lead">
                Today, the Maldivian post-secondary education sector is growing rapidly, with an increasing number of private providers entering the sector to meet the demand. Emerging from this growing importance of post-secondary education is the concomitant requirement to assure the quality of qualifications awarded in testimony of educational attainments. Thus, the Maldives NationalQualifications Framework (MNQF) is designed to:
            </p>
            <ul class="list-unstyled lead">
                <li>- Facilitate the development of a quality assurance mechanism for the post-secondary education sector.</li>
                <li>- Provide a framework for recognition of qualifications offered in the Maldives and abroad.</li>
            </ul>
            <p class="lead">
                MNQF provides a comprehensive and coherent national framework that facilitates quality improvement, quality assurance, and private sector participation in post- secondary education. MNQF also ensures that students, employers, education providers and the community at large easily understand the learning outcomes involved in various qualifications.
            </p>
        </b-col>
        <page-heading heading="Local Institutes"/>
        <b-card no-body>
            <b-tabs pills card>
                <div v-for="tab in tabs" v-if="institutes && checkDisabled">
                    <b-tab :active="tab === checkDisabled[0]"
                           :disabled="!checkDisabled.includes(tab)"
                           :title="tab">
                        <ul class="list-unstyled">
                            <div v-for="institute in institutes">   
                                <li v-if="institute.name.startsWith(tab)">
                                    <router-link :to="{ name: 'institute', params: { institute_id: institute.id } }">   
                                        <h5 class="font-weight-light">
                                            <img v-if="institute.logo" :src="institute.logo" alt="Institute Logo" style="max-width: 95px; max-height: 95px">
                                            {{institute.name}}
                                        </h5>
                                    </router-link>
                                    <hr>
                                </li>
                            </div>
                        </ul>
                    </b-tab>
                </div>
            </b-tabs>
        </b-card>
        <router-view></router-view>
    </b-container>
</template>
<script>
import PageHeading from '@/components/SharedComponents/PageHeading.vue'
import axios from 'axios'
import arraySort from 'array-sort'
export default {
    data() {
        return{
            institutes: null,
            // 
            tabs: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']
        }
    },
    computed: {
        checkDisabled(){
            let isDisabled = []
            this.tabs.forEach((element) => {
                isDisabled.push((this.institutes.filter((institute) => 
                    element === institute.name.charAt(0)
                )[0]) ? element : false) 
            })
            return isDisabled.filter(disabled => disabled ? disabled : null)
        }
    },
    methods: {
        getInstitutes() {
            axios.get(this.API_URL + '/institutes/local').then((response) => {
                this.institutes = response.data
            }, (error) => {
                console.log(error)
            })

            // Need to sort array
        },
        
    },
    components: {
        PageHeading
    },
    beforeCreate() {
        document.title = "Local Institutes"
    },
    created() {
        
    },
    beforeMount() {
        this.getInstitutes()
    },
    mounted() {
        
    },
    beforeUpdate() {
        
    },
    updated() {

    }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/SharedComponents/Local.vue